// Copyright (c) 2025 Audere, All Rights Reserved

import { Box } from "@mui/material";
import { Outlet } from "react-router";
import { createStyleSheet } from "../utils/styles";

const Projects = () => {
  return (
    <Box sx={styles.projectsContainer}>
      <Outlet />
    </Box>
  );
};

export default Projects;

const styles = createStyleSheet({
  projectsContainer: {
    width: "100%",
    height: "100%",
  },
});
